import { useEffect, useState } from 'react';
import { fetchMe, onIdentityChange } from '@/lib/session.js';

// Who the server says this sign-in is (GET /api/tracon/auth/me, cached per token in
// lib/session.js). null while loading and on any failure: callers hide, never assume. A token
// swapped in another tab re-asks (review L5-SEC-2); its removal is RequireAuth's (auth:expired).
export default function useMe() {
  const [me, setMe] = useState(null);
  useEffect(() => {
    let live = true;
    const ask = () => fetchMe().then((d) => { if (live) setMe(d); });
    ask();
    const off = onIdentityChange((token) => { if (!live) return; setMe(null); if (token) ask(); });
    return () => { live = false; off(); };
  }, []);
  return me;
}
